if (!customElements.get('swatch-slider')) {
  customElements.define(
    'swatch-slider',
    class SwatchSlider extends HTMLElement {
      connectedCallback() {
        this.isDown = false;
        this.startX = 0;
        this.scrollStart = 0;
        this.dragDistance = 0;
        this.lastX = 0;
        this.lastTime = 0;
        this.velocity = 0;
        this.momentumFrame = null;

        this._cancelMomentum = () => {
          if (this.momentumFrame) {
            cancelAnimationFrame(this.momentumFrame);
            this.momentumFrame = null;
          }
        };

        this._onDown = (e) => {
          this._cancelMomentum();
          this.isDown = true;
          this.dragDistance = 0;
          this.velocity = 0;
          this.startX = e.pageX;
          this.lastX = e.pageX;
          this.lastTime = performance.now();
          this.scrollStart = this.scrollLeft;
          this.classList.add('is-dragging');
          document.addEventListener('mousemove', this._onMove);
          document.addEventListener('mouseup', this._onUp);
        };

        this._onMove = (e) => {
          if (!this.isDown) return;
          e.preventDefault();
          const walk = e.pageX - this.startX;
          this.dragDistance = walk;
          this.scrollLeft = this.scrollStart - walk;

          const now = performance.now();
          const dt = now - this.lastTime;
          if (dt > 0) {
            this.velocity = (this.lastX - e.pageX) / dt;
          }
          this.lastX = e.pageX;
          this.lastTime = now;
        };

        this._runMomentum = () => {
          const friction = 0.94;
          const minSpeed = 0.05;
          const step = () => {
            if (Math.abs(this.velocity) < minSpeed) {
              this.momentumFrame = null;
              return;
            }
            this.scrollLeft += this.velocity * 16;
            this.velocity *= friction;
            this.momentumFrame = requestAnimationFrame(step);
          };
          this.momentumFrame = requestAnimationFrame(step);
        };

        this._onUp = () => {
          if (!this.isDown) return;
          this.isDown = false;
          this.classList.remove('is-dragging');
          document.removeEventListener('mousemove', this._onMove);
          document.removeEventListener('mouseup', this._onUp);
          if (Math.abs(this.velocity) > 0.05) this._runMomentum();
        };

        this._onClickCapture = (e) => {
          if (Math.abs(this.dragDistance) > 5) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        };

        this._onWheelOrTouch = () => this._cancelMomentum();
        this._preventDragstart = (e) => e.preventDefault();

        this.addEventListener('mousedown', this._onDown);
        this.addEventListener('click', this._onClickCapture, { capture: true });
        this.addEventListener('wheel', this._onWheelOrTouch, { passive: true });
        this.addEventListener('touchstart', this._onWheelOrTouch, { passive: true });
        this.querySelectorAll('img').forEach((img) =>
          img.addEventListener('dragstart', this._preventDragstart)
        );
      }

      disconnectedCallback() {
        this._cancelMomentum?.();
        this.removeEventListener('mousedown', this._onDown);
        this.removeEventListener('click', this._onClickCapture, { capture: true });
        this.removeEventListener('wheel', this._onWheelOrTouch);
        this.removeEventListener('touchstart', this._onWheelOrTouch);
        document.removeEventListener('mousemove', this._onMove);
        document.removeEventListener('mouseup', this._onUp);
      }
    }
  );
}
